<template>
	<div class="user-upload">
		<div class="bk-form">
			<worksPictures :is-edited="true" :logo-img="logoImg" :cover-img="coverImg" :preview-img="previewImg" @upPictureId="allPictureIds" @removePicture="removePicture"></worksPictures>
			<div class="upload-action">
        <a :class="['bk-button', 'bk-primary',{'is-loading':saveFlag === false}]" id="submit" @click="save" title="提交">
          <span>提交</span>
        </a>
	      <a class="bk-button bk-return" title="返回" @click="back">
	        <span>返回</span>
	      </a>
	    </div>
    </div>
    <!-- 弹出框子组件 -->
    <v-alert :options="options"></v-alert>
	</div>
</template>
<script>
	import Vue from 'vue'
	import vAlert from '../../alert.vue'
	import worksPictures from './common/works_pictures.vue'

	export default {
		data () {
			return {
        saveFlag: true, //提交按钮
				logoImg: '',
				coverImg: '',
				previewImg: [],
				imagesIdList: [0, 0, 0, 0, 0],
				options: {
          msgText: "",
          msgIsSuccess: true
        }
			}
		},
		components: {
			worksPictures,
			vAlert
		},
		methods: {
			/*
       ** 获取产品信息
       */
      getBasicInfo() {
        const app_id = this.$route.params.wid;
        axios.get(myUrl + `core/product/info/${app_id}/`, {
          params: {
            keyword: 'picture'
          }
        }).then((res) => {
          if (res.data.result) {
            let pictures = res.data.data.app_picture;

            // logo
            this.logoImg = pictures.logo[0]
            this.imagesIdList[0] = pictures.logo[1]

            // cover
            this.coverImg = pictures.large_logo[0]
            this.imagesIdList[1] = pictures.large_logo[1]
	
            // preview
            let images = pictures.images
            images.forEach((img, index) => {
            	this.previewImg.push(img[0])
            	this.imagesIdList[index + 2] = img[1]
            })
          } else {
            this.options = {
              msgIsSuccess: false,
              msgText: res.data.message
            }
          }
        })
      },
      checkData () {
        if (!this.imagesIdList[0]) {
          this.options = {
            msgText: '请上传作品LOGO',
            msgIsSuccess: false
          }
          return false
        }

        if (!this.imagesIdList[1]) {
          this.options = {
            msgText: '请上传作品封面',
            msgIsSuccess: false
          }
          return false
        }

        if (!this.imagesIdList[2] && !this.imagesIdList[3] && !this.imagesIdList[4]) {
          this.options = {
            msgText: '请上传至少1张作品截图',
            msgIsSuccess: false
          }
          return false
        }

        return true
      },
      save () {
        this.saveFlag = false;
        setTimeout(() => {
          this.saveFlag = true
        }, 3000)
        if (!this.checkData()) {
          return false
        }
      	let workId = this.$route.params.wid
      	let params = {
      		keyword: 'picture',
      		images: JSON.stringify(this.imagesIdList)
      	}

        axios.post(myUrl + `core/product/update/${workId}/`, qs.stringify(params)).then((response) => {
          let res = response.data
       
          if (res.result) {

            this.options = {
              msgIsSuccess: true,
              msgText: '更新成功'
            };
          } else {
            this.options = {
              msgIsSuccess: false,
              msgText: res.message
            };
          }
        })
      },
      /*
       ** 监听上传图片子组件
       */
      allPictureIds (data) {
        switch (data.type) {
          case 'logo':
            this.imagesIdList[0] = data.imgId;
            break;

          case 'cover':
            this.imagesIdList[1] = data.imgId;
            break;

          case 'firstAvatar':
            this.imagesIdList[2] = data.imgId;
            break;

          case 'secondAvatar':
            this.imagesIdList[3] = data.imgId;
            break;

          case 'thirdAvatar':
            this.imagesIdList[4] = data.imgId;
            break;
        }
      },
      removePicture (data) {
        switch (data.type) {
          case 'logo':
            this.imagesIdList[0] = 0;
            break;

          case 'cover':
            this.imagesIdList[1] = 0;
            break;

          case 'firstAvatar':
            this.imagesIdList[2] = 0;
            break;

          case 'secondAvatar':
            this.imagesIdList[3] = 0;
            break;

          case 'thirdAvatar':
            this.imagesIdList[4] = 0;
            break;
        }
      },
      back () {
      	window.history.go(-1)
      }
		},
		created () {
			this.getBasicInfo()
		}
	} 
</script>

<style media="screen" lang="scss" scoped>
	.upload-action {
		display: table;
    padding: 50px 30px 50px 40px !important;
	}
</style>


// WEBPACK FOOTER //
// basic_works_pictures.vue?8ba29106